import printJS from 'print-js';

/**
 * @param {Blob} blob
 * @param {string} filename
 */
export function downloadBlob(blob, filename) {
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(blobUrl);
}

/**
 * @param {Blob} blob
 * @returns {Promise<void>}
 */
export function printPdfBlob(blob) {
    return new Promise((resolve, reject) => {
        const fr = new FileReader();

        fr.addEventListener('error', () => {
            reject(new Error('Failed to read PDF for printing'));
        });

        fr.addEventListener('load', () => {
            try {
                const { result } = fr;

                if (typeof result !== 'string') {
                    reject(new Error('Failed to read PDF for printing'));
                    return;
                }

                const base64Index = result.indexOf('base64,');
                if (base64Index === -1) {
                    reject(new Error('Failed to read PDF for printing'));
                    return;
                }

                const tmpPDFdata = result.slice(base64Index + 7);
                printJS({ printable: tmpPDFdata, type: 'pdf', base64: true });
                resolve();
            } catch (error) {
                reject(error instanceof Error ? error : new Error('Failed to print PDF'));
            }
        });

        fr.readAsDataURL(blob);
    });
}

/**
 * @param {Response} downloadResponse
 * @param {string} defaultFileName - Used as the download name unless overridden by Content-Disposition when useServerFileNameIfAvailable is true.
 * @param {boolean} [useServerFileNameIfAvailable=true] - When true, Content-Disposition filename wins when present. When false, defaultFileName is always used.
 */
export const fileDownload = async (downloadResponse, defaultFileName, useServerFileNameIfAvailable = true) => {
    const blob = await downloadResponse.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;

    const contentDisposition = downloadResponse.headers.get('Content-Disposition');
    let serverFilename = null;
    if (contentDisposition) {
        const filenameMatch = contentDisposition.split('filename=')[1];
        if (filenameMatch) {
            serverFilename = filenameMatch.replace(/"/g, '');
        }
    }

    link.download = defaultFileName;

    if (useServerFileNameIfAvailable && serverFilename) {
        link.download = serverFilename;
    }

    link.click();
    window.URL.revokeObjectURL(blobUrl);
};
